<template>
  <van-button type="primary" class="sub-btn" @click="$emit('click')">
    <slot>
      确定
    </slot>
  </van-button>
</template>

<script>
export default {
  name: 'WhSubButton'
}
</script>

<style lang="less" scoped>
.sub-btn {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  width: 100%;
  background: @primary-color;
  border: none;
}
</style>
